import { mapPaginated } from '@sb/feathers-types';
import type { Routine } from '@sb/remote-control/types';
import { convertRoutineResponse } from '@sb/remote-control/util/convertRoutineResponse';

import { getLocateSkillByIdFromStore } from '../skills/skillsStore';

import { getRoutinesService } from './utils';

export async function getRoutine(
  routineID: string,
): Promise<Routine.ConvertedResponse | null> {
  const response = await getRoutinesService().find({
    query: { id: routineID, $limit: 1 },
  });

  const routine =
    mapPaginated(response, (data) =>
      convertRoutineResponse(data, {
        getLocateSkillById: getLocateSkillByIdFromStore,
      }),
    )[0] ?? null;

  return routine;
}
